export const lessonConstants = {
  // Fetch selected lesson
  FETCH_SELECTED_LESSON: "FETCH_SELECTED_LESSON",
  SELECTED_LESSON_SUCCESS: "SELECTED_LESSON_SUCCESS",
  SELECTED_LESSON_FAILURE: "SELECTED_LESSON_FAILURE",

  FETCH_ALL_LESSON_REQUEST: "FETCH_ALL_LESSON_REQUEST",
  FETCH_ALL_LESSON_SUCCESS: "FETCH_ALL_LESSON_SUCCESS",
  FETCH_ALL_LESSON_FAILURE: "FETCH_ALL_LESSON_FAILURE",
  // Set selected lesson if already exsists in store
  SET_SELECTED_LESSON_DATA: "SET_SELECTED_LESSON_DATA",

  //For Parents change modal
  FETCHING_SUBCOURSES: "FETCHING_SUBCOURSES",
  FETCHING_SUBCOURSES_SUCCESS: "FETCHING_SUBCOURSES_SUCCESS",
  FETCHING_SUBCOURSES_FAILED: "FETCHING_SUBCOURSES_FAILED",

  FETCHING_SECTIONS: "FETCHING_SECTIONS",
  FETCHING_SECTIONS_SUCCESS: "FETCHING_SECTIONS_SUCCESS",
  FETCHING_SECTIONS_FAILED: "FETCHING_SECTIONS_FAILED",

  MOVING_LESSON: "MOVING_LESSON",
  MOVE_LESSON_SUCCESS: "MOVE_LESSON_SUCCESS",
  MOVE_LESSON_FAILED: "MOVE_LESSON_FAILED",

  CHANGE_PUBLISH_STATUS: "CHANGE_PUBLISH_STATUS",
  CHANGE_PUBLISH_STATUS_SUCCESS: "CHANGE_PUBLISH_STATUS_SUCCESS",
  CHANGE_PUBLISH_STATUS_FAILED: "CHANGE_PUBLISH_STATUS_FAILED",

  DISPLAY_NAME_CHANGE: "DISPLAY_NAME_CHANGE",
  NAME_CHANGE: "NAME_CHANGE",
  DISPLAY_NAME_CHANGE_SUCCESS: "DISPLAY_NAME_CHANGE_SUCCESS",
  NAME_CHANGE_SUCCESS: "NAME_CHANGE_SUCCESS",
  NAME_CHANGES_FAILED: "NAME_CHANGES_FAILED",

  DESCRIPTION_UPDATE: "DESCRIPTION_UPDATE",
  DESCRIPTION_UPDATE_SUCCESS: "DESCRIPTION_UPDATE_SUCCESS",
  DESCRIPTION_UPDATE_FAILED: "DESCRIPTION_UPDATE_FAILED",

  VIDEO_LINK_UPDATE: "VIDEO_LINK_UPDATE",
  VIDEO_LINK_UPDATE_SUCCESS: "VIDEO_LINK_UPDATE_SUCCESS",
  VIDEO_LINK_UPDATE_FAILED: "VIDEO_LINK_UPDATE_FAILED",

  LESSON_DELETE_REQUEST: "LESSON_DELETE_REQUEST",
  LESSON_DELETE_SUCCESS: "LESSON_DELETE_SUCCESS",
  LESSON_DELETE_FAILURE: "LESSON_DELETE_FAILURE",

  SET_NODE_REQUEST: "SET_NODE_REQUEST",
  SET_NODE_SUCCESS: "SET_NODE_SUCCESS",
  SET_NODE_FAILURE: "SET_NODE_FAILURE",

  /* Specifically for "Add Selected Deck" to Lessons we have to fetch all courses,s
    ubcourses, sections,lessons from the DB (not only author courses,sections,subcourses but ALL)
    to show their name in  AddSelectedDecks component*/
  FETCHING_ALL_COURSES_REQUEST: "FETCHING_ALL_COURSES_REQUEST_FROM_DB",
  FETCHING_ALL_COURSES_SUCCESS: "FETCHING_ALL_COURSES_SUCCESS_FROM_DB",
  FETCHING_ALL_COURSES_FAILURE: "FETCHING_ALL_COURSES_FAILURE_FROM_DB",

  FETCHING_ALL_SUBCOURSES_REQUEST: "FETCHING_ALL_SUBCOURSES_REQUEST_FROM_DB",
  FETCHING_ALL_SUBCOURSES_SUCCESS: "FETCHING_ALL_SUBCOURSES_SUCCESS_FROM_DB",
  FETCHING_ALL_SUBCOURSES_FAILURE: "FETCHING_ALL_SUBCOURSES_FAILURE_FROM_DB",

  FETCHING_ALL_SECTIONS_REQUEST: "FETCHING_ALL_SECTIONS_REQUEST_FROM_DB",
  FETCHING_ALL_SECTIONS_SUCCESS: "FETCHING_ALL_SECTIONS_SUCCESS_FROM_DB",
  FETCHING_ALL_SECTIONS_FAILURE: "FETCHING_ALL_SECTIONS_FAILURE_FROM_DB",

  CREATE_DECK_BANK_REQUEST: "CREATE_DECK_BANK_REQUEST1",
  CREATE_DECK_BANK_SUCCESS: "CREATE_DECK_BANK_SUCCESS1",
  CREATE_DECK_BANK_FAILURE: "CREATE_DECK_BANK_FAILURE1",

  EDIT_DECK_BANK_REQUEST: "EDIT_DECK_BANK_REQUEST1",
  EDIT_DECK_BANK_SUCCESS: "EDIT_DECK_BANK_SUCCESS1",
  EDIT_DECK_BANK_FAILURE: "EDIT_DECK_BANK_FAILURE1",

  DELETE_DECK_BANK_REQUEST: "DELETE_DECK_BANK_REQUEST1",
  DELETE_DECK_BANK_SUCCESS: "DELETE_DECK_BANK_SUCCESS1",
  DELETE_DECK_BANK_FAILURE: "DELETE_DECK_BANK_FAILURE1",

  FETCHING_ALL_ITEM_BANKS: "FETCHING_ALL_ITEM_BANKS",
  FETCHING_ALL_ITEM_BANKS_SUCCESS: "FETCHING_ALL_ITEM_BANKS_SUCCESS",
  FETCHING_ALL_ITEM_BANKS_FAILURE: "FETCHING_ALL_ITEM_BANKS_FAILURE",

  UPDATE_ITEM_BANKS_REQUEST: "UPDATE_ITEM_BANKS_REQUEST",
  UPDATE_ITEM_BANKS_SUCCESS: "UPDATE_ITEM_BANKS_SUCCESS",
  UPDATE_ITEM_BANKS_FAILURE: "UPDATE_ITEM_BANKS_FAILURE",

  FETCH_ALL_DECK_BANK_REQUEST: "FETCH_ALL_DECK_BANK_REQUEST1",
  FETCH_ALL_DECK_BANK_SUCCESS: "FETCH_ALL_DECK_BANK_SUCCESS1",
  FETCH_ALL_DECK_BANK_FAILURE: "FETCH_ALL_DECK_BANK_FAILURE1",

  FETCH_LESSON_DECKS_REQUEST: "FETCH_LESSON_DECKS_REQUEST1",
  FETCH_LESSON_DECKS_SUCCESS: "FETCH_LESSON_DECKS_SUCCESS1",
  FETCH_LESSON_DECKS_FAILURE: "FETCH_LESSON_DECKS_FAILURE1",

  FETCH_ALL_DECKLOGICS_REQUEST: "FETCH_ALL_DECKLOGICS_REQUEST1",
  FETCH_ALL_DECKLOGICS_SUCCESS: "FETCH_ALL_DECKLOGICS_SUCCESS1",
  FETCH_ALL_DECKLOGICS_FAILURE: "FETCH_ALL_DECKLOGICS_FAILURE1",

  UPDATE_DECK_INDEX_REQUEST: "UPDATE_DECK_INDEX_REQUEST1",
  UPDATE_DECK_INDEX_SUCCESS: "UPDATE_DECK_INDEX_SUCCESS1",
  UPDATE_DECK_INDEX_FAILURE: "UPDATE_DECK_INDEX_FAILURE1",

  ADD_DECK_REQUEST: "ADD_DECK_IN_LESSON_REQUEST1",
  ADD_DECK_SUCCESS: "ADD_DECK_IN_LESSON_SUCCESS1",
  ADD_DECK_FAILURE: "ADD_DECK_IN_LESSON_FAILURE1",

  DELETE_DECK_REQUEST: "DELETE_DECK_IN_LESSON_REQUEST1",
  DELETE_DECK_SUCCESS: "DELETE_DECK_IN_LESSON_SUCCESS1",
  DELETE_DECK_FAILURE: "DELETE_DECK_IN_LESSON_FAILURE1",

  CREATE_DECK_LOGIC_REQUEST: "CREATE_DECK_LOGIC_REQUEST1",
  CREATE_DECK_LOGIC_SUCCESS: "CREATE_DECK_LOGIC_SUCCESS1",
  CREATE_DECK_LOGIC_FAILURE: "CREATE_DECK_LOGIC_FAILURE1",

  EDIT_DECK_LOGIC_REQUEST: "EDIT_DECK_LOGIC_REQUEST1",
  EDIT_DECK_LOGIC_SUCCESS: "EDIT_DECK_LOGIC_SUCCESS1",
  EDIT_DECK_LOGIC_FAILURE: "EDIT_DECK_LOGIC_FAILURE1",

  EDIT_DECK_BANK_LOGIC_REQUEST: "EDIT_DECK_BANK_LOGIC_REQUEST1",
  EDIT_DECK_BANK_LOGIC_SUCCESS: "EDIT_DECK_BANK_LOGIC_SUCCESS1",
  EDIT_DECK_BANK_LOGIC_FAILURE: "EDIT_DECK_BANK_LOGIC_FAILURE1",

  DELETE_DECK_LOGIC_REQUEST: "DELETE_DECK_LOGIC_REQUEST1",
  DELETE_DECK_LOGIC_SUCCESS: "DELETE_DECK_LOGIC_SUCCESS1",
  DELETE_DECK_LOGIC_FAILURE: "DELETE_DECK_LOGIC_FAILURE1",

  DELETE_DECK_LOGIC_FROM_BANK_REQUEST: "DELETE_DECK_FROM_BANK_LOGIC_REQUEST1",
  DELETE_DECK_LOGIC_FROM_BANK_SUCCESS: "DELETE_DECK_FROM_BANK_LOGIC_SUCCESS1",
  DELETE_DECK_LOGIC_FROM_BANK_FAILURE: "DELETE_DECK_FROM_BANK_LOGIC_FAILURE1",

  CREATE_DIRECTIVE_REQUEST: "CREATE_DIRECTIVE_REQUEST1",
  CREATE_DIRECTIVE_SUCCESS: "CREATE_DIRECTIVE_SUCCESS1",
  CREATE_DIRECTIVE_FAILURE: "CREATE_DIRECTIVE_FAILURE1",
  EDIT_DIRECTIVE_REQUEST: "EDIT_DIRECTIVE_REQUEST1",
  EDIT_DIRECTIVE_SUCCESS: "EDIT_DIRECTIVE_SUCCESS1",
  EDIT_DIRECTIVE_FAILURE: "EDIT_DIRECTIVE_FAILURE1",
  DELETE_DIRECTIVE_REQUEST: "DELETE_DIRECTIVE_REQUEST1",
  DELETE_DIRECTIVE_SUCCESS: "DELETE_DIRECTIVE_SUCCESS1",
  DELETE_DIRECTIVE_FAILURE: "DELETE_DIRECTIVE_FAILURE1",

  LESSON_ITEM_BANK_REQ: "LESSON_ITEM_BANK_REQ",
  LESSON_ITEM_BANK_SUCCESS: "LESSON_ITEM_BANK_SUCCESS",
  LESSON_ITEM_BANK_FAILURE: "LESSON_ITEM_BANK_FAILURE",

  SAVE_ITEMS_TO_BANK: "SAVE_ITEMS_TO_BANK",
  SAVE_ITEMS_TO_BANK_SUCCESS: "SAVE_ITEMS_TO_BANK_SUCCESS",
  SAVE_ITEMS_TO_BANK_FAILURE: "SAVE_ITEMS_TO_BANK_FAILURE",

  SORT_ITEMS_IN_BANK: "SORT_ITEMS_IN_BANK",
  SORT_ITEMS_IN_BANK_SUCCESS: "SORT_ITEMS_IN_BANK_SUCCESS",
  SORT_ITEMS_IN_BANK_FAILURE: "SORT_ITEMS_IN_BANK_FAILURE",

  DELETE_ITEMS_FROM_BANK: "DELETE_ITEMS_FROM_BANK",
  DELETE_ITEMS_FROM_BANK_SUCCESS: "DELETE_ITEMS_FROM_BANK_SUCCESS",
  DELETE_ITEMS_FROM_BANK_FAILURE: "DELETE_ITEMS_FROM_BANK_FAILURE",

  LESSON_ALLOTED_TIME_CHANGE: "LESSON_ALLOTED_TIME_CHANGE",
  LESSON_ALLOTED_TIME_CHANGE_SUCCESS: "LESSON_ALLOTED_TIME_CHANGE_SUCCESS",
  LESSON_ALLOTED_TIME_CHANGE_FAILED: "LESSON_ALLOTED_TIME_CHANGE_FAILED"
}
